import React from 'react'
import styled, { StyledProps } from 'styled-components'
import { FormField } from '../../form'
import { dynamicInputCss, focusInputCss } from '../Input/styles'

type TextAreaProps = {
  id?: string
  name?: string
  limit?: number
  value?: string
  label?: string
  className?: string
  invalid?: boolean
  errorText?: string
  disabled?: boolean
  readonly?: boolean
  required?: boolean
  optional?: boolean
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
}

const TextAreaStyled = styled.textarea<StyledProps<TextAreaProps>>`
  min-height: 104px;
  width: 100%;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 10px;
  box-sizing: border-box;
  outline: none;
  resize: none;
  margin: 0;
  border: none;

  &:not(:read-only) {
    &:focus {
      ${focusInputCss}
    }
  }

  ${props => props.theme.media.mobile`
    font-size: 16px;
  `}

  ${dynamicInputCss}

  &:read-only {
    background-color: ${props => props.theme.color.backgroundBase};
    cursor: not-allowed;
  }
`

type Props = TextAreaProps & Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'onChange' | 'value'>

export const TextArea = React.forwardRef<HTMLTextAreaElement, Props>(
  (
    {
      className,
      id,
      name,
      limit,
      value,
      onChange,
      errorText,
      invalid,
      disabled,
      label,
      required,
      readonly,
      optional,
      ...rest
    },
    ref,
  ) => {
    return (
      <FormField
        componentType={'textArea'}
        id={id}
        name={name}
        limit={limit}
        errorText={errorText}
        invalid={invalid}
        label={label}
        value={value}
        required={required}
        optional={optional}
        render={({ id, name }) => (
          <TextAreaStyled
            className={className}
            disabled={disabled}
            invalid={invalid}
            ref={ref}
            maxLength={limit}
            id={id}
            name={name}
            value={value || ''}
            onChange={onChange}
            readOnly={readonly}
            data-field-invalid={invalid}
            {...rest}
          />
        )}
      />
    )
  },
)
